export default __webpack_public_path__ + "static/media/logo.da0665f1.png";